module.exports = __webpack_public_path__ + "static/media/back12345.f47fd6b8.webp";